import { Environment } from '@src/config/enums';

export const getIdApiUrls: Record<Environment, string> = {
    Dev: 'https://superbet.sb.getid.dev',
    Qa: 'https://superbet.sb.getid.dev',
    Stage: 'https://superbet.sb.getid.dev',
    Prod: 'https://superbet.getid.ee', // Different than the rest!
};

let uploadedFile = null as File | null;

export const setUploadedFile = (file: File) => {
    uploadedFile = file;
};

export const getUploadedFile = () => {
    return uploadedFile;
};

export const destroyUploadedFile = () => {
    uploadedFile = null;
};
